module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-579.12eabb9.woff2";